/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Schedule_Window_StartInputs */

const vi_irrigation_schedule_window_start = /** @type {(inputs: Irrigation_Schedule_Window_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Từ`)
};

/**

* @param {Irrigation_Schedule_Window_StartInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_schedule_window_start = /** @type {((inputs?: Irrigation_Schedule_Window_StartInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Schedule_Window_StartInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_schedule_window_start(inputs)
});